<template>
  <div class="mobile-container">
    <img class="pear-code" src="../resource/about1.jpg"/>
    <div class="text1-div">
      <div class="br-line-spacing">
        在南阳博望的黄金梨果园里，每一颗幼果不仅被果袋细心保护，更拥有了自己的“数字身份证”。果袋上印制的二维码，记录着这颗黄金梨从开花、坐果、套袋、施肥到成熟的全过程。只需轻轻一扫，消费者便能看到每一次管理记录、采摘时间、果农信息以及产地环境，让一颗梨的成长路径真正做到透明可查。
      </div>

      <div class="br-line-spacing">
        这一套二维码溯源体系，是黄金梨优享汇对品质最坚定的承诺：
      </div>

      <div class="br-line-spacing">
        让每一颗梨都拥有可追踪的生命轨迹，让每一位消费者都能放心吃、明白吃。
      </div>

      <div class="br-line-spacing">
        过去，好的水果只能凭经验去判断；如今，我们用科技把经验转化为看得见的数据，让质量不再依赖“运气”，让美味有据可依。
      </div>

      <div class="br-line-spacing">
        这些挂在枝头的小小二维码，是果农智慧的结晶，也是品牌对安全、真实与信任的坚持。在这里，我们不仅种梨，更种下对每一位消费者的责任心。
      </div>

      <div class="br-line-spacing">
        黄金梨优享汇——每一颗梨，都能被追溯；每一口甜，都值得信赖
      </div>
    </div>
    <div class="br-line-spacing-padding">
      <!--用于填充图片和文字的空白框-->
    </div>
    <img class="pear-pick" src="../resource/about2.jpg"/>

    <div class="text2-div">
      清晨的薄雾还未散尽，南阳博望的梨园里已经忙碌起来。果农戴着草帽，小心翼翼地托起一颗颗金黄饱满的黄金梨，轻捏枝梢、缓缓一转，只采摘自然成熟、形圆色正的好果。多年经验告诉他：只有在阳光刚好、果香最浓的时刻下树，梨的口感才又脆又甜、入口爆汁。每一颗被放入筐中的黄金梨，都是一整年施肥、疏果、套袋、看天的心血结晶。正是这一双双朴实的手，让“黄金梨优享汇”送到你家餐桌上的，不只是水果，而是来自博望土地的真实清甜与踏实安心。
    </div>
    <div class="br-line-spacing-padding">
      <!--用于填充图片和文字的空白框-->
    </div>
    <img class="pear-pick" src="../resource/about3.jpg"/>

    <div class="text3-div">
      <div class="br-line-spacing">
        在南阳博望，每一颗黄金梨的故事，都从这一刻开始。果农蹲在翻起的土壤旁，双手托着即将种下的幼苗，仔细察看根须是否健壮、泥土是否湿润。旁边的伙伴正缓缓浇下第一瓢定根水，让小小的树苗在大地的怀抱中稳稳安家。
      </div>

      <div class="br-line-spacing">
        种梨，最重要的不是快，而是稳、是扎根、是对土地的尊重与依靠。为了让未来的黄金梨长得更甜、更脆、更爆汁，果农们从第一道工序就格外用心：选苗、挖坑、定根、覆土，每一步都做到精细、做到踏实。
      </div>

      <div class="br-line-spacing">
        这片土地见证了他们的坚持，也孕育了黄金梨优享汇的底气。正是这份坚持，让每一颗后来送到你手中的黄金梨，都不仅仅是水果，更是从土壤深处生长出的真实、自然与安心。
      </div>
    </div>
    <div class="br-line-spacing-padding">
      <!--用于填充图片和文字的空白框-->
    </div>
  </div>
</template>

<script>
import {onMounted, ref} from 'vue';
// import {useRouter} from 'vue-router';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'About',
  setup() {
    // const router = useRouter();
    const user = ref({});
    const isCollapse = ref(true); // 默认折叠菜单
    const menuList = ref([]);
    const defaultActive = ref(null);
    const checkTabName = ref(null);

    onMounted(() => {
      // user.value = JSON.parse(sessionStorage.getItem("loginUser"));
      // 添加触摸事件支持
    });

    return {
      user,
      isCollapse,
      menuList,
      defaultActive,
      checkTabName,
    };
  },
};
</script>

<style scoped>
/* 可选：清除默认边距，避免滚动异常 */
body, html {
  margin: 0;
  padding: 0;
}

/* 基础样式 */
.mobile-container {
  height: 94vh;
  width: 100%;
  position: fixed;
  overflow-y: auto;
  /* 隐藏横向滚动条（防止意外横向滚动） */
  overflow-x: hidden;
  /* 可选：优化滚动体验（iOS端） */
  /*background: linear-gradient(to bottom right, #33872B, #d8ffd0);*/
  background-color: #F2F2E8;/* 白色*/
  /*background-color: #33872B;*//* 绿色*/
  /*background-color: #EAF0E6;*/ /* 黄白色*/
  /* 可选：子元素之间的间距（按需调整） */
  gap: 5px;
  align-items: flex-start; /* 垂直顶部对齐 */
  justify-content: center; /* 水平居中对齐 */
  top: 0;
  left: 0;
}

/*上面的一果一码*/
.pear-code {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  height: 20%;
}

/*文字1的div框*/
.text1-div {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  text-align: left; /* 文字左对齐 */
  width: 96vw;
  height: auto;
}

/*行间距*/
.br-line-spacing {
  padding-top: 1vh;
  height: auto;
}

/*行间距*/
.br-line-spacing-padding {
  height: 1vh;
}

/*下面的图片*/
.pear-pick {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  /* 给个基础尺寸，可根据需求调整 */
  height: 30%;
}

/*文字2的div框*/
.text2-div {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  margin-left: 2vw;
  margin-right: 2vw;
  margin-top: 1vh;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  /* 给个基础尺寸，可根据需求调整 */
  text-align: left; /* 文字左对齐 */
  height: auto;
}


/*文字3的div框*/
.text3-div {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  /* 给个基础尺寸，可根据需求调整 */
  text-align: left; /* 文字左对齐 */
  height: auto;
}
</style>